import { useMemo } from "react";

import DOMPurify from "dompurify";
import { css } from "@emotion/react";
import { generateHTML } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";

import { BANNER_LEVEL_LABELS, useBannerLevels, useBannerStyles } from "shared";

import { useMaintenanceBanner } from "./hooks";

const MaintenanceBanner = () => {
    const { data: bannerData } = useMaintenanceBanner();

    const { activeLevelOption } = useBannerLevels(
        bannerData?.level ?? BANNER_LEVEL_LABELS.Warning
    );

    const { generalStyles } = useBannerStyles();

    const parseTiptapContent = (content: string | undefined) => {
        if (!content) return "";

        try {
            const rawHtml = generateHTML(JSON.parse(content), [StarterKit]);
            return DOMPurify.sanitize(rawHtml, { ADD_ATTR: ["target"] });
        } catch {
            return "";
        }
    };

    const htmlOutput = useMemo(
        () => parseTiptapContent(bannerData?.message),
        [bannerData?.message]
    );

    if (!bannerData?.isActive) return null;

    return (
        <div
            css={css({
                padding: "8px 29px",
                background: activeLevelOption.background,
                textAlign: "center",
                boxShadow: "none",
                zIndex: "2"
            })}
        >
            <div
                dangerouslySetInnerHTML={{ __html: htmlOutput }}
                css={css(generalStyles)}
            />
        </div>
    );
};

export default MaintenanceBanner;
